import footer1_Init from "@common/components/footer-1";


const global = () => {
  footer1_Init();
};
export default global;
